export const SIDE_PANEL_SECONDARY_DOCK_MODES = Object.freeze({
  INLINE: 'inline',
  DETACHED: 'detached',
});

export const SIDE_PANEL_SECONDARY_DOCK_IDS = Object.freeze({
  LAYERS: 'layers',
  SCENE3D_OBJECTS: 'scene3dObjects',
  EFFECT_WORKBENCH: 'effectWorkbench',
});

export const SIDE_PANEL_INLINE_SCROLL_MODES = Object.freeze({
  SPLIT: 'split',
  UNIFIED: 'unified',
});

export const DEFAULT_SIDE_PANEL_SECONDARY_RATIO = 0.4;
export const MIN_SIDE_PANEL_SECONDARY_RATIO = 0.28;
export const MAX_SIDE_PANEL_SECONDARY_RATIO = 0.68;

// Pane width defaults. These are the single source for the panel-width fact:
// theme.css projects them into CSS custom properties and layoutConstants.js
// derives its geometry from them, so neither copy can drift.
export const DEFAULT_SIDE_PANEL_PRIMARY_WIDTH = 345;
export const SIDE_PANEL_SECONDARY_DOCK_WIDTH_RATIO = 0.78;
export const DEFAULT_SIDE_PANEL_SECONDARY_DOCK_WIDTH = DEFAULT_SIDE_PANEL_PRIMARY_WIDTH
  * SIDE_PANEL_SECONDARY_DOCK_WIDTH_RATIO;

// "Within reason": the floor is today's secondary width; the ceiling sits ABOVE
// the default, so a pane can be made wider than it opens rather than only
// narrower. Both panes share one range.
export const MIN_SIDE_PANEL_PANE_WIDTH = Math.round(DEFAULT_SIDE_PANEL_SECONDARY_DOCK_WIDTH);
export const MAX_SIDE_PANEL_PANE_WIDTH = 400;

export const SIDE_PANEL_PANE_WIDTH_STEP = 8;
export const SIDE_PANEL_PANE_WIDTH_STEP_LARGE = 32;

export const DEFAULT_SIDE_PANEL_DOCK_WIDTHS = Object.freeze({
  primary: DEFAULT_SIDE_PANEL_PRIMARY_WIDTH,
  secondaryDock: DEFAULT_SIDE_PANEL_SECONDARY_DOCK_WIDTH,
});
